export function useDrawerPosition(placement) {
  switch (placement) {
    case 'top':
      return {
        horizontal: 'dock',
        vertical: 'top'
      };

    case 'bottom':
      return {
        horizontal: 'dock',
        vertical: 'bottom'
      };

    case 'left':
      return {
        horizontal: 'left',
        vertical: 'dock'
      };

    case 'right':
      return {
        horizontal: 'right',
        vertical: 'dock'
      };
  }
}